module.exports = __webpack_public_path__ + "static/media/spotify-logo.96a319e0.png";